import React, {useContext, useEffect} from "react";
import toast from "react-hot-toast";
import LoadingButton from "@mui/lab/LoadingButton";
import RefreshIcon from "@mui/icons-material/Refresh";
import {useNavigate} from "react-router-dom";
import {GlobalDataContext} from "./GlobalDataProvider";
import {useAuth} from "../auth/AuthProvider";
import {api} from "../api/Api";

export const RefreshButton = () => {
  const {setUpdateMessage} = useContext(GlobalDataContext);
  const {getUpdatedDataTime} = useContext(GlobalDataContext);
  const {isDataUpdating} = useContext(GlobalDataContext);
  const {setIsDataUpdating} = useContext(GlobalDataContext);
  const auth = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isDataUpdating) {
      getUpdatedDataTime();
    }
  }, [isDataUpdating]);

  const handleDataRefresh = async () => {
    const token = auth.token;
    if (!token) {
      navigate("/");
      toast.error("Přihlášení vypršelo!");
      return
    }
    try {
      await api.get(`/dataset/update`, {
        headers: { Authorization: token },
      });
      setIsDataUpdating(true);
      getUpdatedDataTime();
    } catch (error) {
      setUpdateMessage("Při aktualizaci dat došlo k chybě. Zkuste to znovu...");
      console.error(error);
      if (error.response?.status === 401) navigate("/");
    }
  };

  return (
      <LoadingButton
        size="small"
        onClick={handleDataRefresh}
        endIcon={<RefreshIcon />}
        loading={isDataUpdating}
        loadingPosition="end"
        variant="contained"
      >
        Aktualizovat
      </LoadingButton>
  );
};